import { Spinner, Stack, Text } from '@chakra-ui/react';

export function LoadingOverlay({ message }: { message: string }) {
  return (
    <Stack
      alignItems='center'
      bg='rgba(255,255,255,.8)'
      bottom={0}
      justifyContent='center'
      left={0}
      position='absolute'
      right={0}
      top={0}
      zIndex={2}
      sx={{
        backdropFilter: 'blur(1px)',
      }}
    >
      <Spinner borderLeftColor='blue.500' borderRightColor='blue.500' borderTopColor='blue.500' />
      <Text size='label'>{message}</Text>
    </Stack>
  );
}
